import { Build, Step } from "~/components/build/Show/lib/types";
import { keepPreviousData, queryOptions, skipToken, UseQueryOptions } from "@tanstack/react-query";
import fetcher from "~/components/build/Show/lib/fetcher";

interface StepSearchResult {
  records: Step[];
  totalCount: number;
}

export const stepSearchQueryKey = (buildId: Build["id"], search: string) => {
  return ["build", buildId, "steps", "search", search];
};

export const stepSearchQueryOptions = (
  build: Build,
  search: string,
  queryOptionsArgs: Omit<UseQueryOptions<StepSearchResult>, "queryKey" | "queryFn"> = {},
) => {
  const trimmedSearch = search.trim();
  const { enabled: callerEnabled, ...restOptions } = queryOptionsArgs;
  const enabled = !!trimmedSearch && (callerEnabled ?? true);

  return queryOptions({
    queryKey: stepSearchQueryKey(build.id, trimmedSearch),
    queryFn: enabled
      ? ({ signal }) => fetchStepSearch(build.buildDataBasePath, trimmedSearch, signal)
      : skipToken,
    enabled,
    placeholderData: keepPreviousData,
    ...restOptions,
  });
};

function fetchStepSearch(
  buildDataBasePath: Build["buildDataBasePath"],
  search: string,
  signal: AbortSignal,
): Promise<StepSearchResult> {
  const url = new URL(`${buildDataBasePath}/steps`, window.location.origin);
  url.searchParams.set("search", search);

  return fetcher<StepSearchResult>(url, true, { signal });
}
